<template>
    <h1>Test</h1>
</template>

<script>
    export default {
        name: "New"
    }
</script>

<style scoped>

</style>